import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import StandardButton from "@/components/buttons/StandardButton.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import debounce from "lodash/debounce";
// @ts-ignore
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import WDialog from "@/components/wrappers/w-dialog.vue";
import Loader from "@/components/loader/Loader.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import axios from "axios";
let ImageUploader = class ImageUploader extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "orientation", void 0);
    _defineProperty(this, "imageMaxSize", void 0);
    _defineProperty(this, "customAspectRatio", void 0);
    _defineProperty(this, "croppedMaxWidth", void 0);
    _defineProperty(this, "croppedMaxHeight", void 0);
    _defineProperty(this, "uploadApiUrl", void 0);
    _defineProperty(this, "cropper", null);
    _defineProperty(this, "fileUploadUrl", "");
    _defineProperty(this, "cropperPreviewUrl", "");
    _defineProperty(this, "isCropping", false);
    _defineProperty(this, "choosedFile", null);
    _defineProperty(this, "imageCropResult", null);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "isVisible", false);
  }
  mounted() {
    this.isVisible = this.visible;
  }
  onVisiblePropChanges() {
    this.isVisible = this.visible;
  }
  get cropperSourceImage() {
    return this.$refs.cropperSource;
  }
  get canvasOptions() {
    let canvasOptions = {};
    if (this.orientation) {
      switch (this.orientation) {
        case "portrait":
          canvasOptions.maxHeight = this.croppedMaxHeight || 1280;
          break;
        case "landscape":
          canvasOptions.maxWidth = this.croppedMaxWidth || 1280;
          break;
        case "square":
          canvasOptions.maxHeight = this.croppedMaxHeight || 720;
          break;
      }
    } else {
      canvasOptions = {
        ...canvasOptions,
        ...this.autoComputeCanvasDimensions()
      };
    }
    return canvasOptions;
  }
  /**
   * Since there is no orientation, we auto-compute real canvas dimensions based on user freestyle cropping and ratio
   * to the original image dimensions
   */
  autoComputeCanvasDimensions() {
    const canvasDimensions = {};
    if (this.cropper) {
      // Récupérer les données de la zone croppée dans l'image source
      const imageData = this.cropper.getImageData();
      const cropBoxData = this.cropper.getCropBoxData();
      const canvasData = this.cropper.getCanvasData();
      // Calculer le scale factor entre l'affichage et l'image réelle
      const scaleX = imageData.naturalWidth / canvasData.width;
      const scaleY = imageData.naturalHeight / canvasData.height;
      // Dimensions réelles de la zone croppée
      const realCropWidth = cropBoxData.width * scaleX;
      const realCropHeight = cropBoxData.height * scaleY;
      let finalWidth, finalHeight;
      if (this.croppedMaxWidth && this.croppedMaxHeight) {
        finalWidth = Math.min(realCropWidth, this.croppedMaxWidth);
        finalHeight = Math.min(realCropHeight, this.croppedMaxHeight);
      } else if (this.croppedMaxWidth) {
        finalWidth = Math.min(realCropWidth, this.croppedMaxWidth);
        finalHeight = Math.round(finalWidth * (realCropHeight / realCropWidth));
      } else if (this.croppedMaxHeight) {
        finalHeight = Math.min(realCropHeight, this.croppedMaxHeight);
        finalWidth = Math.round(finalHeight * (realCropWidth / realCropHeight));
      } else {
        finalWidth = Math.min(realCropWidth, 720);
        finalHeight = Math.round(finalWidth * (realCropHeight / realCropWidth));
      }
      return {
        ...canvasDimensions,
        width: finalWidth,
        height: finalHeight
      };
    }
    return canvasDimensions;
  }
  onFileUploaded($event) {
    const file = $event?.raw;
    if (file) {
      if (file.size / 1024 / 1024 > this.imageMaxSize) {
        WElMessage.showErrorMessage(this.$t('imageUploader.error.onSizeExceed', {
          imgMaxSize: this.imageMaxSize
        }));
        return false;
      } else {
        this.setupCropper($event.raw);
      }
    }
  }
  setupCropper(file) {
    this.choosedFile = file;
    // Destroy existing cropper first (with try-catch in case DOM was already removed)
    if (this.cropper) {
      this.cropper.destroy();
    }
    if (this.fileUploadUrl) {
      window.URL.revokeObjectURL(this.fileUploadUrl);
      this.fileUploadUrl = "";
    }
    if (!this.choosedFile) {
      this.cropperPreviewUrl = "";
      this.isCropping = false;
      this.cropper = null;
      return;
    }
    this.fileUploadUrl = window.URL.createObjectURL(this.choosedFile);
    this.isCropping = true;
    // Wait for Vue to render the new DOM element with the new key
    this.$nextTick(() => {
      const cropperOptions = {
        viewMode: 0,
        dragMode: "move",
        autoCropArea: 0.98,
        restore: false,
        guides: true,
        center: true,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
        crop: debounce(this.updateCropperPreview, 200)
      };
      this.appendCustomCropperOptions(cropperOptions);
      this.cropper = new Cropper(this.cropperSourceImage, cropperOptions);
    });
  }
  appendCustomCropperOptions(cropperOptions) {
    if (this.customAspectRatio) {
      cropperOptions.aspectRatio = this.customAspectRatio;
    } else {
      switch (this.orientation) {
        case "portrait":
          cropperOptions.aspectRatio = 9 / 16;
          break;
        case "landscape":
          cropperOptions.aspectRatio = 16 / 9;
          break;
        case "square":
          cropperOptions.aspectRatio = 1;
          break;
      }
    }
    return cropperOptions;
  }
  removeImage() {
    this.cleanupCropper();
  }
  validateCropping() {
    if (this.cropper) {
      const croppedCanvas = this.cropper.getCroppedCanvas(this.canvasOptions);
      // Safety check - canvas might be null if cropper is in invalid state
      if (!croppedCanvas) {
        this.cleanupCropper();
        return;
      }
      // Create a new canvas with white background
      const finalCanvas = document.createElement("canvas");
      finalCanvas.width = croppedCanvas.width;
      finalCanvas.height = croppedCanvas.height;
      const ctx = finalCanvas.getContext("2d");
      if (ctx) {
        // Fill with white background
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
        // Draw the cropped image on top
        ctx.drawImage(croppedCanvas, 0, 0);
      }
      this.imageCropResult = {
        fileName: this.choosedFile?.name || '',
        imageB64: finalCanvas.toDataURL("image/png")
      };
      if (this.uploadApiUrl) {
        this.uploadImage(this.imageCropResult);
      } else {
        this.$emit("imageGenerated", this.imageCropResult);
        this.closeModal();
      }
    }
  }
  uploadImage(imageCropResult) {
    if (this.uploadApiUrl) {
      const postData = {
        fileName: imageCropResult.fileName,
        imageB64: imageCropResult.imageB64
      };
      this.isLoading = true;
      axios.post(this.uploadApiUrl, postData).then(response => {
        const uploadResult = response.data;
        this.$emit("uploadResult", uploadResult);
        this.closeModal();
      }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default'))).finally(() => this.isLoading = false);
    }
  }
  cancelCropping() {
    this.closeModal();
  }
  closeModal() {
    this.isVisible = false;
    this.cleanupCropper();
    return false;
  }
  updateCropperPreview() {
    if (this.cropper) {
      const canvas = this.cropper.getCroppedCanvas();
      if (canvas) {
        this.cropperPreviewUrl = canvas.toDataURL("image/png");
      }
    }
  }
  resetCropper() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }
  rotateLeft() {
    if (this.cropper) {
      this.cropper.rotate(-90);
    }
  }
  rotateRight() {
    if (this.cropper) {
      this.cropper.rotate(90);
    }
  }
  zoomPlus() {
    if (this.cropper) {
      this.cropper.zoom(0.2);
    }
  }
  zoomMinus() {
    if (this.cropper) {
      this.cropper.zoom(-0.2);
    }
  }
  cleanupCropper() {
    if (this.cropper) {
      try {
        this.cropper.destroy();
      } catch (e) {
        // Cropper might fail to destroy if DOM element was already removed
      }
      this.cropper = null;
    }
    if (this.fileUploadUrl) {
      window.URL.revokeObjectURL(this.fileUploadUrl);
      this.fileUploadUrl = "";
    }
    this.cropperPreviewUrl = "";
    this.isCropping = false;
    this.choosedFile = null;
    this.imageCropResult = null;
    this.isLoading = false;
  }
};
__decorate([Prop({
  default: false
})], ImageUploader.prototype, "visible", void 0);
__decorate([Prop({
  default: null
})], ImageUploader.prototype, "orientation", void 0);
__decorate([Prop({
  default: 2
})], ImageUploader.prototype, "imageMaxSize", void 0);
__decorate([Prop({
  default: null
})], ImageUploader.prototype, "customAspectRatio", void 0);
__decorate([Prop({
  default: null
})], ImageUploader.prototype, "croppedMaxWidth", void 0);
__decorate([Prop({
  default: null
})], ImageUploader.prototype, "croppedMaxHeight", void 0);
__decorate([Prop({
  default: null
})], ImageUploader.prototype, "uploadApiUrl", void 0);
__decorate([Watch('visible')], ImageUploader.prototype, "onVisiblePropChanges", null);
__decorate([Emit("close")], ImageUploader.prototype, "closeModal", null);
ImageUploader = __decorate([Component({
  components: {
    Loader,
    IconButton,
    StandardButton,
    WDialog
  },
  emits: ['uploadResult', 'imageGenerated']
})], ImageUploader);
export default ImageUploader;